<!-- <div class="lendingLogo">
  <h2 class="title"><strong>MS</strong> World</h2>
  <span>
    <img src="./assets/images/lending-club.jpg" alt="" />
  </span>
</div> -->
<ng-template #loaderBlock>
  <motif-progress-loader [show]="true" [fullScreen]="true"></motif-progress-loader>
</ng-template>
<div class="card-wrapper">
  <app-card
    class="app-card"
    *ngFor="let clientData of clientList"
    [data]="clientData"
  ></app-card>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
